













































































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import TextField from '@/components/legacy/TextField.vue';
import ChevronIcon from '@/components/ChevronIcon.vue';
import { LocaleMessages } from 'vue-i18n';
import isMobile from '@/utils/isMobile';

@Component({
  components: {
    TextField,
    ChevronIcon,
  },
})
export default class AutocompleteField extends Vue {
  @Model('change') modelValue!: any;
  @Prop({ type: [String, Object] }) label?: string | LocaleMessages;
  @Prop({ type: Array, required: true }) items!: any[];
  @Prop({ type: String, default: 'name' }) itemText!: string;
  @Prop({ type: String, default: 'id' }) itemKey!: string;
  @Prop({ type: Function }) filter?: (
    item: any,
    queryText: string,
    itemText: string
  ) => any;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) showChangeButton!: string;

  private query: string = '';
  private focused: boolean = false;
  private resultsHover: boolean = false;
  private isMobile: boolean = false;
  private windowHeight: number = 0;

  private get showResults(): boolean {
    return !!this.items.length && (this.focused || this.resultsHover);
  }

  private created() {
    this.isMobile = isMobile();
    this.windowHeight = window.innerHeight;
    if (this.isMobile) {
      window.visualViewport.addEventListener(
        'resize',
        this.onContainerSizeChange
      );
    }
  }

  beforeDestroy() {
    window.visualViewport.removeEventListener(
      'resize',
      this.onContainerSizeChange
    );
  }

  @Emit('search')
  onSearch(value: any): any {
    this.query = value;
    return value;
  }

  @Emit('change')
  onChange(value: any): any {
    if (this.isMobile) this.focused = false;
    this.resultsHover = false;
    return value;
  }

  @Watch('focused')
  onFocusedChange(current: boolean) {
    if (current && !this.query) {
      this.$emit('focused');
    }
  }

  @Watch('modelValue')
  private onModelValueChange(current: any) {
    if (current) {
      this.query = '';
    }
  }

  private onContainerSizeChange() {
    if (window.innerHeight !== this.windowHeight) {
      window.scroll(0, 0);
      this.windowHeight = window.innerHeight;
    }
  }

  onQueryChange(value: string) {
    this.onChange(null);
    this.query = value;
  }
}
